import { render, staticRenderFns } from "./BuildingsIcon.vue?vue&type=template&id=bbd2e858&scoped=true&"
import script from "./BuildingsIcon.vue?vue&type=script&lang=js&"
export * from "./BuildingsIcon.vue?vue&type=script&lang=js&"
import style0 from "./BuildingsIcon.vue?vue&type=style&index=0&id=bbd2e858&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bbd2e858",
  null
  
)

export default component.exports